// extracted by mini-css-extract-plugin
module.exports = {"tablePadding":"BaseTable_tablePadding_2_UhK","tableMarginBot":"BaseTable_tableMarginBot_2PbMD"};